<div class="flyout-audience-component">
  <div class="flyout-headline-row">
    <div class="headline-title">
      @if (audienceIsExisting === false) {
        <span>{{ "audience.settings.new-audience" | translate }}</span>
      }
      @if (audienceIsExisting === true) {
        <span>{{ "audience.settings.edit-audience" | translate }}</span>
      }
    </div>
    <div class="header-close-icon">
      <mat-icon class="close-icon" (click)="cancelFlyout()">close</mat-icon>
    </div>
  </div>

  <div class="flyout-audience-settings">
    @if (audienceIsExisting === false && showSuggestions === true) {
      Empty with suggestions
    }
    @if (audienceIsExisting === true || showSuggestions === false) {
      <div class="audience-name-section">
        <form [formGroup]="updateFormGroup" (ngSubmit)="!updateInProgress && audience?.isDefault === false ? saveAudience() : ''">
          <mat-form-field hideRequiredMarker appearance="outline" class="audience-name-field">
            <mat-label>{{ "audience.settings.audience-name" | translate }}</mat-label>
            <input
              matInput
              required
              type="text"
              name="name"
              placeholder="{{ 'audience.settings.audience-name' | translate }}"
              [formControlName]="'audienceName'"
              [matTooltip]="'audience.default-audience-disabled' | translate"
              [matTooltipDisabled]="!audience || audience.isDefault !== true"
              data-test="audience-name" />
            @if (updateFormGroup.get("audienceName").invalid && updateFormGroup.get("audienceName").dirty && updateFormGroup.get("audienceName").value.length) {
              <mat-hint class="error">
                {{ "audience.statistics.invalid-input" | translate }}
              </mat-hint>
            }
            @if (
              updateFormGroup.get("audienceName").invalid && updateFormGroup.get("audienceName").dirty && !updateFormGroup.get("audienceName").value.length
            ) {
              <mat-hint class="error">
                {{ "audience.validation.no-name" | translate }}
              </mat-hint>
            }
          </mat-form-field>
        </form>
      </div>
      <div class="audience-filters-section">
        <div class="audience-filters-section-title">{{ "audience.settings.all-users-that" | translate | uppercase }}</div>
        <div class="audience-filters-container">
          @for (audienceFilter of audienceFilters; track audienceFilter.id ?? $index; let index = $index; let isLast = $last) {
            <div class="filter-chip-box">
              <div
                class="filter-chip"
                data-test="audience-filter-chip"
                [class.is-example-audience]="!!exampleAudienceConfig"
                [class.no-value-on-example]="!audienceFilter.value"
                [class.disabled]="audience?.isDefault === true"
                [matTooltip]="'audience.default-audience-disabled' | translate"
                [matTooltipDisabled]="!audience || audience.isDefault !== true"
                (click)="openAudienceFilterDialog(audienceFilter, index)">
                @if (audienceFilter.filterConfig && audienceFilter.filterConfig.app) {
                  <img [src]="audienceFilter.filterConfig.iconUrl" class="app-image" />
                }
                <div class="filter-text">
                  <span class="filter-type">{{ audienceFilter.filterTranslations?.type }}</span>
                  <span class="filter-operator">{{ audienceFilter.filterTranslations?.operator }}</span>
                  @if (audienceFilter.filterTranslations?.value && audienceFilter.filterConfig.type !== AudienceFilterType.Purchase) {
                    <span [innerHTML]="audienceFilter.filterTranslations?.value" class="filter-value"></span>
                  }
                  @if (audienceFilter.filterTranslations?.timeframeOperator) {
                    <span [innerHTML]="audienceFilter.filterTranslations?.timeframeOperator" class="filter-operator"></span>
                  }
                  @if (!audienceFilter.filterTranslations?.timeframeOperator && audienceFilter.filterConfig?.type === AudienceFilterType.Purchase) {
                    <span class="filter-operator">
                      {{ "audience.timeframeOperators." + AudienceFilterTimeOperator.AnyTime | translate }}
                    </span>
                  }
                  @if (audienceFilter.filterTranslations?.timeframeValue) {
                    <span class="filter-value">
                      {{ audienceFilter.filterTranslations?.timeframeValue | lowercase }}
                    </span>
                  }
                </div>
                @if (audienceFilter && audienceFilter.filterConfig?.isNew) {
                  <span class="new-addon" style="margin: 0 10px 0; padding: 0 5px">NEW</span>
                }
                @if (false) {
                  <span class="admin-only-tag" style="display: flex; margin-left: 5px; line-height: normal">
                    <mat-icon class="admin-only-tag-sub" style="color: #f59100">font_download</mat-icon>
                  </span>
                }
                <mat-icon class="filter-icon" (click)="removeAudienceFilter(index, $event)">cancel</mat-icon>
              </div>
              @if (!isLast) {
                <div class="filter-text-and">&</div>
              }
              @if (isLast) {
                <span class="filter-text-space">&nbsp;</span>
              }
            </div>
          }
          <div class="filter-chip-box add-filter">
            @if (audience?.isDefault !== true) {
              <div class="filter-chip" [matMenuTriggerFor]="audienceFiltersMenu">
                <mat-icon class="filter-icon">add</mat-icon>
                <div class="filter-text">{{ "audience.settings.add-filter" | translate }}</div>
              </div>
            }
          </div>
        </div>
        <mat-menu #audienceFiltersMenu="matMenu" class="audience-filters-dropdown-menu">
          <div fxLayout="row" fxLayout.xs="column">
            <div class="criteria-section">
              @for (filterConfig of supportedFilterConfigs; track $index) {
                <ng-container>
                  @if (filterConfig.type !== AudienceFilterType.LoggedIn || loggedInDetectionEnabled) {
                    <button mat-menu-item (click)="addFilterToAudience(filterConfig)" [disabled]="filterConfig.disabled || isLimitReached(filterConfig)">
                      @if (filterConfig.iconUrl) {
                        <img [src]="filterConfig.iconUrl" class="criteria-image" />
                      }
                      @if (!filterConfig.iconUrl) {
                        <mat-icon class="criteria-icon" [ngClass]="filterConfig.icon">{{ filterConfig.icon }}</mat-icon>
                      }
                      <span [class.disabled]="isDisabled(filterConfig)">{{ filterConfig.titleOverride || (filterConfig.titleKey | translate) }}</span>
                      @if (filterConfig.disabledOnTiers) {
                        <app-account-upgrade-tag [disabled]="!isDisabled(filterConfig)"></app-account-upgrade-tag>
                      }
                      @if (filterConfig.isNew) {
                        <span class="new-addon" style="margin: 0 10px 0; padding: 2px 5px; line-height: normal">NEW</span>
                      }
                    </button>
                  }
                </ng-container>
              }
            </div>
          </div>
        </mat-menu>
      </div>
      @if (currentAccount) {
        <div class="audience-reach-section">
          <div class="audience-reach-section-title">{{ "audience.statistics.campaign-reach-title" | translate | uppercase }}</div>
          @if (
            audienceToCalculateReach !== undefined &&
            audienceToCalculateReach.reach !== undefined &&
            audienceToCalculateReach.reach !== -1 &&
            totalAudienceWeeklyReach !== undefined
          ) {
            <div class="audience-reach-bar">
              <div [style.width.%]="reachPercentage" class="audience-reach-indicator"></div>
              <div class="audience-reach-label value">{{ audienceToCalculateReach?.reach }}</div>
              <div class="audience-reach-label of">{{ "generic.of" | translate | lowercase }}</div>
              <div class="audience-reach-label total">{{ totalAudienceWeeklyReach }}</div>
              <div class="audience-reach-label of">{{ "generic.visitors" | translate | lowercase }}</div>
            </div>
            <div class="audience-reach-info">
              <mat-icon>help_outline</mat-icon>
              <span>{{ "audience.reach.based-on" | translate }}</span>
            </div>
          }
          @if (
            audienceToCalculateReach !== undefined &&
            audienceToCalculateReach.reach !== undefined &&
            audienceToCalculateReach.reach !== -1 &&
            totalAudienceWeeklyReach === undefined
          ) {
            <div class="audience-reach-total">
              <span>
                <b>{{ audienceToCalculateReach.reach }}&nbsp;</b>
              </span>
              <span>{{ "audience.reach.total" | translate }}</span>
            </div>
          }
          @if (audienceToCalculateReach !== undefined && (audienceToCalculateReach.reach === undefined || audienceToCalculateReach.reach === -1)) {
            <div class="audience-reach-info">{{ "audience.cant-calculate-reach" | translate }}</div>
          }
        </div>
      }
      @if (audience?.isDefault !== true) {
        <div class="and-or-or-section">
          <mat-radio-group
            class="and-or-or"
            color="primary"
            [(ngModel)]="currentAudienceOperator"
            [matTooltip]="'audience.tooltip-no-and-nor-or' | translate"
            [matTooltipDisabled]="audienceFilters.length > 0 && conditions.length > 0"
            [disabled]="audienceFilters.length === 0 || conditions.length === 0">
            <mat-radio-button [value]="AudienceOperators.And" class="operator-btn">{{ "generic.and" | translate | titlecase }}</mat-radio-button>
            <mat-radio-button [value]="AudienceOperators.Or" class="operator-btn">{{ "generic.or" | translate | titlecase }}</mat-radio-button>
          </mat-radio-group>
          <div class="condition-group-filters-section-title">{{ "audience.session-condition-groups.under-conditions" | translate | uppercase }}</div>
        </div>
      }
      @if (audience?.isDefault !== true) {
        <div class="condition-group-filters-section">
          <div class="condition-group-filters-container">
            @for (conditionFilter of conditions; track conditionFilter.id ?? $index; let index = $index; let isLast = $last) {
              <div class="condition-chip-box">
                <div
                  class="condition-chip"
                  [class.clickable]="!!conditionFilter.conditionConfig.defaultOperator"
                  [class.is-example-audience]="!!exampleAudienceConfig"
                  [class.no-value-on-example]="!conditionFilter.value && !conditionFilter.notEditable"
                  (click)="openSessionConditionDialog(conditionFilter, index)"
                  [matTooltip]="conditionFilter.conditionConfig.descriptionKey | translate"
                  [matTooltipDisabled]="!!conditionFilter.conditionConfig.defaultOperator">
                  @if (!conditionFilter.conditionConfig.svgIcon) {
                    <mat-icon class="condition-icon">{{ conditionFilter.conditionConfig.icon }}</mat-icon>
                  }
                  @if (conditionFilter.conditionConfig.svgIcon) {
                    <mat-icon class="condition-icon tb-icon" [svgIcon]="conditionFilter.conditionConfig.svgIcon"></mat-icon>
                  }
                  <div class="filter-text">
                    <span class="filter-type">{{ conditionFilter.conditionTranslations?.type }}</span>
                    @if (conditionFilter.conditionTranslations?.operator) {
                      <span class="filter-operator">
                        {{ conditionFilter.conditionTranslations?.operator }}
                      </span>
                    }
                    @if (conditionFilter.conditionTranslations?.value) {
                      <span [innerHTML]="conditionFilter.conditionTranslations?.value" class="filter-value"></span>
                    }
                    @if (conditionFilter.conditionConfig.isNew) {
                      <span class="new-addon">NEW</span>
                    }
                  </div>
                  <mat-icon class="filter-icon" (click)="removeSessionCondition(index, $event)">cancel</mat-icon>
                </div>
                @if (!isLast) {
                  <div class="filter-text-and">&</div>
                }
                @if (isLast) {
                  <span class="filter-text-space">&nbsp;</span>
                }
              </div>
            }
            <div
              class="condition-chip-box add-filter"
              [matTooltip]="'campaign.settings.app-experience-not-supported' | translate"
              [matTooltipDisabled]="!disableSessionConditions">
              <div
                class="condition-chip"
                [class.clickable]="!disableSessionConditions"
                [class.disabled]="disableSessionConditions"
                [matMenuTriggerFor]="disableSessionConditions ? null : sessionConditionsMenu">
                <mat-icon class="filter-icon">add</mat-icon>
                <div class="filter-text">{{ "audience.settings.add-condition" | translate }}</div>
              </div>
            </div>
            <mat-menu #sessionConditionsMenu="matMenu" class="condition-groups-dropdown-menu">
              <div class="conditions-section-wrapper">
                @for (conditionConfigGroup of allConditionsConfigGroups; track conditionConfigGroup.type ?? $index) {
                  <div class="conditions-section">
                    @if (conditionConfigGroup.conditions.length > 0) {
                      <div class="conditions-section-title">
                        <span>{{ "audience.filter-config." + conditionConfigGroup.type | translate | uppercase }}</span>
                      </div>
                    }
                    @for (conditionConfig of conditionConfigGroup.conditions; track conditionConfig.type) {
                      <div>
                        <button mat-menu-item (click)="addConditionToGroup(conditionConfig)" [disabled]="conditionConfig.disabled">
                          @if (!conditionConfig.svgIcon) {
                            <mat-icon class="criteria-icon">{{ conditionConfig.icon }}</mat-icon>
                          }
                          @if (conditionConfig.svgIcon) {
                            <mat-icon class="criteria-icon tb-icon" [svgIcon]="conditionConfig.svgIcon"></mat-icon>
                          }
                          <span class="condition-name" [class.disabled]="isDisabled(conditionConfig)">{{ conditionConfig.titleKey | translate }}</span>
                          @if (conditionConfig.isNew) {
                            <span class="new-addon">NEW</span>
                          }
                          @if (isDisabled(conditionConfig)) {
                            <app-account-upgrade-tag></app-account-upgrade-tag>
                          }
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            </mat-menu>
          </div>
        </div>
      }
      @if (!audience?.isDefault && !!currentAccount && !!currentAccount.groupId && this._openingData?.currentCustomer?.siteIds.length > 1) {
        <div class="audience-account-group-section">
          <div class="enable-section">
            <mat-checkbox #accountGroupCheckbox class="enabled-checkbox" [checked]="availableOnAccountGroup" [disabled]="!!audience?.accountGroupId">
              @if (!audience?.accountGroupId) {
                <span>{{ "audience.customer.enable" | translate }}</span>
              }
              @if (!!audience?.accountGroupId) {
                <span>{{ "audience.customer.available" | translate }}</span>
              }
            </mat-checkbox>
            <div class="enabled-hint">
              <mat-icon>help_outline</mat-icon>
              @if (!audience?.accountGroupId) {
                <span [innerHTML]="'audience.customer.title-text' | translate"></span>
              }
              @if (!!audience?.accountGroupId) {
                <span>{{ "audience.customer.available-hint" | translate }}</span>
              }
            </div>
          </div>
        </div>
      }
      @if (audienceIsExisting) {
        <div class="audience-usage-section">
          <div class="audience-usage-section-title">{{ "audience.statistics.campaign-usage-title" | translate | uppercase }}</div>
          @if (!loadingWidgetsForAudience) {
            @if (!numOfCampaigns || numOfCampaigns === 0) {
              <div class="audience-campaigns-row">
                <div class="campaigns-usage-text">{{ "audience.statistics.no-campaigns" | translate }}</div>
              </div>
            }
            @if (numOfCampaigns && numOfCampaigns > 0) {
              <div class="audience-campaigns-row">
                <div class="campaigns-usage-text">
                  <span
                    [innerHTML]="'audience.statistics.campaign-usage' | translate: { count: numOfCampaigns, publishedCount: numOfPublishedCampaigns }"></span>
                  <span>&nbsp;</span>
                  @if (!showCampaignDetails) {
                    <span (click)="showCampaignDetails = true" class="link-text">{{ "generic.show" | translate }}</span>
                  }
                  @if (showCampaignDetails) {
                    <span (click)="showCampaignDetails = false" class="link-text">{{ "generic.hide" | translate }}</span>
                  }
                </div>
              </div>
            }
            @if (showCampaignDetails) {
              <div class="campaign-details-container">
                @for (campaignDetails of audienceCampaignsArray; track campaignDetails.campaignId) {
                  <div class="campaign-details-box">
                    <div class="status-box">
                      <div
                        class="indicator"
                        [class.active]="ACTIVE_CMP_STATUSES.indexOf(campaignDetails.status) !== -1"
                        [class.inactive]="INACTIVE_CMP_STATUSES.indexOf(campaignDetails.status) !== -1"
                        [class.draft]="CampaignStatuses.Draft === campaignDetails.status"></div>
                    </div>
                    <div class="campaign-name link-color" (click)="openCampaignOverviewInNewTab(campaignDetails.campaignId)">
                      <span>{{ campaignDetails.name }}</span>
                      <mat-icon>open_in_new</mat-icon>
                    </div>
                    <div class="spacer"></div>
                    <div
                      class="action"
                      [matTooltip]="'audience.statistics.cant-disconnect-active' | translate"
                      [matTooltipDisabled]="ACTIVE_CMP_STATUSES.indexOf(campaignDetails.status) === -1"
                      [class.disabled]="ACTIVE_CMP_STATUSES.indexOf(campaignDetails.status) !== -1"
                      (click)="disconnectCampaignFromAudience(campaignDetails)">
                      {{ "generic.disconnect" | translate | uppercase }}
                    </div>
                  </div>
                }
              </div>
            }
          }
          @if (loadingWidgetsForAudience) {
            <div class="campaigns-usage-text">{{ "generic.loading" | translate }}</div>
          }
        </div>
      }
      <div class="spacer"></div>
      @if (isRemovable && true && audienceIsExisting === true && audience?.isDefault !== true) {
        <div class="delete-button-row">
          <div
            class="delete-button-container"
            [matTooltip]="numOfCampaigns > 0 ? ('audience.cant-delete' | translate) : ('audience.cant-delete-other-accounts' | translate)"
            [matTooltipDisabled]="this.numOfCampaignsOnAllAccounts === 0 && this.numOfCampaigns === 0">
            <button
              mat-stroked-button
              class="delete-button"
              deleteDialog
              [disabled]="this.loadingWidgetsDataForAudience || this.numOfCampaignsOnAllAccounts > 0 || this.numOfCampaigns > 0"
              deletionType="{{ 'generic.audience' | translate | lowercase }}"
              deletionTypeText="{{ audience?.name | bold }}"
              deletionTypeHeader="{{ 'confirmationDialog.confirmationTitle' }}"
              deletionText="{{ 'confirmationDialog.delete-audience' }}"
              (onDelete)="deleteAudience()">
              <span class="btn-label">
                @if (!deleteInProgress) {
                  <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                }
                @if (deleteInProgress) {
                  <mat-spinner class="spinner" [diameter]="18" [mode]="'indeterminate'" [class.inProgress]="deleteInProgress"></mat-spinner>
                }
                <span>{{ "audience.delete-audience" | translate }}</span>
              </span>
            </button>
          </div>
        </div>
      }
    }
  </div>

  <div class="flyout-bottom-row">
    <button class="secondary-button" mat-stroked-button (click)="cancelFlyout()">
      <span class="btn-label">{{ "generic.cancel" | translate | uppercase }}</span>
    </button>
    <button
      class="primary-button"
      mat-stroked-button
      [disabled]="updateInProgress || audience?.isDefault === true"
      [matTooltip]="'audience.default-audience-disabled' | translate"
      [matTooltipDisabled]="!audience || audience.isDefault !== true"
      (click)="saveAudience()">
      @if (updateInProgress) {
        <mat-spinner class="spinner" [diameter]="18" [mode]="'indeterminate'" [class.inProgress]="updateInProgress"></mat-spinner>
      }
      <span class="btn-label">{{ "generic.save" | translate | uppercase }}</span>
    </button>
  </div>
</div>
